import { bunja } from 'bunja';
import { atom } from 'jotai';

import { pricePredictionBunja } from './state';

export const predictionCardBunja = bunja(() => {
  const { pricePredictionAtom, roundInfoAtom } = bunja.use(pricePredictionBunja);

  const eventPeriodAtom = atom((get) => {
    const prediction = get(pricePredictionAtom);
    return {
      start: prediction?.eventStartTime,
      end: prediction?.eventEndTime,
    };
  });

  return {
    eventPeriodAtom,
    roundInfoAtom,
  };
});
predictionCardBunja.debugLabel = 'predictionCardBunja';
